import FiltroImpressaoStep from "./filtro-impressao.component";
import GridProdutosStep from "./grid-produtos-impressao.component";

const ImpressaoEtiquetaStepper = ({
  listaEtiquetas,
  setListaEtiquetas,
  nfEntrada,
  setNfEntrada,
  listaOpcoesNfEntrada,
  setListaOpcoesNfEntrada,
  activeStep,
  etiqueta,
  setEtiqueta,
  produtos,
  setProdutos,
  produtoSelecionado,
  setProdutoSelecionado,
  listaOpcoesProdutos,
  setListaOpcoesProdutos,
  filtroImpressao,
  setFiltroImpressao,
  inputErros
}) => {
  switch (activeStep) {
    case 1:
      return (
        <GridProdutosStep
          produtos={produtos}
          setProdutos={setProdutos}
          inputErros={inputErros}
        />
      );
    default:
      return (
        <FiltroImpressaoStep
          etiqueta={etiqueta}
          setEtiqueta={setEtiqueta}
          listaEtiquetas={listaEtiquetas} 
          setListaEtiquetas={setListaEtiquetas}
          nfEntrada={nfEntrada}
          setNfEntrada={setNfEntrada}
          listaOpcoesNfEntrada={listaOpcoesNfEntrada}
          setListaOpcoesNfEntrada={setListaOpcoesNfEntrada}
          produtoSelecionado={produtoSelecionado}
          setProdutoSelecionado={setProdutoSelecionado}
          listaOpcoesProdutos={listaOpcoesProdutos}
          setListaOpcoesProdutos={setListaOpcoesProdutos}
          filtroImpressao={filtroImpressao}
          setFiltroImpressao={setFiltroImpressao}
          inputErros={inputErros}
        />
      );
  }
};

export default ImpressaoEtiquetaStepper;
